import {
  EDIT_PAGE,
  GET_PAGES,
  ADD_PAGE,
} from "../../shared/constants/ActionTypes";

const initialPages = {
  pages: [],
  pageCount: 0,
};

const pagesReducer = (state = initialPages, action) => {
  switch (action.type) {
    case GET_PAGES:
      return {
        ...state,
        pages: action.payload.pages,
        pageCount: action.payload.pageCount,
      };
    case ADD_PAGE:
      return {
        ...state,
        pages: state.pages.push(action.payload),
        pageCount: (state.pageCount += 1),
      };

    case EDIT_PAGE:
      return {
        ...state,
        pages: state.pages.map((page) => {
          if (page.id === action.payload.id) {
            return action.payload;
          } else {
            return page;
          }
        }),
      };
    default:
      return state;
  }
};

export default pagesReducer;
